import React from "react";

export default function Badge({ children, className = "" }: { children: React.ReactNode, className?: string }) {
  return (
    <div
      className={`inline-flex items-center gap-2 border border-dashed border-slate-300 rounded-[20px] px-3 py-2 text-xs font-medium text-slate-700 shadow-sm ${className}`}
    >
      {children}
    </div>
  );
}
